var map = {
	"./blackGold/footer/Icon-chip.png": 97823,
	"./brownGold/footer/Icon-chip.png": 95064,
	"./darkBlue/footer/Icon-chip.png": 37407,
	"./greenYellow/footer/Icon-chip.png": 17298,
	"./redGold/footer/Icon-chip.png": 77756,
	"./skyBlue/footer/Icon-chip.png": 17851,
	"./whiteGold/footer/Icon-chip.png": 66778,
	"./yellowWhite/footer/Icon-chip.png": 88618
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 11590;